<template>
  <Grid v-if="meta" class="q-pt-lg" style="min-height: 200px" align-content="start">
    <div class="text-body-3 text-secondary-1 q-mb-sm">{{ meta.name }}</div>

    <div v-if="isCompletedOrDismissed && hasContent" class="text-subtitle-1 text-secondary-1">
      <i class="fas fa-user q-mr-xs text-grey3" /> {{ creatorName }}
      <i class="fas fa-calendar-alt text-grey3 q-ml-md q-mr-xs" />
      {{ formatDateForLocale(meta.status_date) }}
    </div>

    <component
      :is="`milestone-${meta.system_name}`"
      v-if="milestone"
      :key="milestone.type"
      :subscription-period-id="periodId"
      :data="milestone"
      :meta="meta"
    />
  </Grid>
</template>

<script>
import MILESTONES_MIXIN from '@/mixins/milestones.mixin'
import MilestoneNoDataAvailable from '@/components/milestones/MilestoneNoDataAvailable'
import COMPONENTS from './content-components'
import { get } from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MilestoneEventContent',
  components: {
    ...COMPONENTS,
    MilestoneNoDataAvailable
  },
  mixins: [MILESTONES_MIXIN],
  props: {
    meta: {
      type: Object,
      required: true
    },
    periodId: {
      type: [String, Number],
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState('subscriptions/subscriptionPeriods', {
      milestones: state => state.milestones
    }),
    creatorName() {
      return this.content && Array.isArray(this.content)
        ? get(this.content, '[0].created_by.name', 'N/A')
        : get(this.content, 'created_by.name', 'N/A')
    },
    milestone() {
      if (!this.milestones) return null
      return this.milestones[this.meta.id]
    },
    content() {
      return get(this, 'milestone.content')
    },
    hasContent() {
      return !((this.content && Array.isArray(this.content) && !this.content.length) || !this.content)
    },
    isCompletedOrDismissed() {
      return this.statusIsPresentIn(this.meta.status, ['completed', 'dismissed'])
    }
  },
  created() {
    this.getMilestone()
  },
  methods: {
    ...mapActions('subscriptions/subscriptionPeriods', {
      dispatchGetMilestone: 'getMilestone'
    }),
    getMilestone() {
      return this.dispatchGetMilestone({
        entityId: this.periodId,
        milestoneId: this.meta.id
      })
    }
  }
}
</script>
